module.exports = __webpack_public_path__ + "img/3.eac7937d.jpg";